import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './StatisticPage.module.scss'
import { Layout, PageHeader, Icon, Card } from 'components'

import { useDispatch, useSelector } from 'react-redux'
import { getAllStatistic } from 'service/StatisticService'
import { setAllStatistic } from 'store/slices/StatisticSlice'
import { useNavigate } from 'react-router-dom'
import userInfo from 'utils/userInfo'
import HeaderCards from './components/HeaderCards/HeaderCards'
import ProfileStatistic from './components/ProfileStatistic/ProfileStatistic'
import HistoryCard from './components/HistoryCard/HistoryCard'
import EmployeeSelectUserId from 'hooks/EmployeeSelect/EmployeeSelectUserId'
import SearchByDivision from './components/ProfileCard/components/SearchByDivision'

const StatisticPage = () => {
  const { t } = useTranslation('common')
  const [data, setData] = useState()
  const dispatch = useDispatch()
  const user = userInfo()
  const [selectedEmp, setSelectedEmp] = useState(user.userId)
  const [selectedEmployeeLabel, setSelectedEmployeeLabel] = useState([])
  const getData = async () => {
    try {
      let response = await getAllStatistic(selectedEmp, data)

      dispatch(
        setAllStatistic({
          allStatistic: response.data,
        }),
      )
    } catch (error) {
    }
  }
  useEffect(() => {
    getData()
  }, [selectedEmp])
  const statisticDatas = useSelector((state) => state.statistic.allStatistic)
  const navigate = useNavigate()

  return (
    <Layout>
      <div className={styles.statistic_wrapper}>
        <PageHeader
          icon={<Icon name="chart" size={28} />}
          title={t('auto.statisticpage.title', 'Статистика')}
          subtitle={user?.is_admin_of ? t('statisticPage.view_all_employees_stats') : (user?.division || '')}
          actions={
            <div style={{ minWidth: 260 }}>
              {user?.is_admin_of ? (
                <EmployeeSelectUserId
                  selectedEmployee={setSelectedEmp}
                  setSelectedEmployeeLabel={setSelectedEmp}
                  service={'task'}
                  isMulti={false}
                />
              ) : (
                <SearchByDivision selectedEmployee={setSelectedEmp} />
              )}
            </div>
          }
        />
        <div className={styles.statistic_blured_block}>
          <div className={styles.block_top_section}>
            <HeaderCards
              data={statisticDatas.ProfileCards}
              isUser={selectedEmp === user.userId ? true : false}
            />
          </div>
          <div className={styles.block_bottom_section}>
            <ProfileStatistic data={statisticDatas?.ProfileStatistic} />
          </div>
          <div className={styles.block_bottom_section}>
            <HistoryCard data={statisticDatas.LastActionCard} />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default StatisticPage
